import { Ajax } from "../../../Common/Ajax";
import { GlobalData } from "../../../Common/GlobalData";
import { Notification } from "../../../Common/KendoHelpers";

export class TheBigPictureModel {
    public tradingDate: string | null = null;
    public dailyAction: string | null = null;
    public currentOutlook: string | null = null;
    public distributionDays: string | null = null;
    public ndqChange: string | null = null;
    public ndqCount: number | null = null;
    public sandP500Count: number | null = null;
    public sandP500Change: string | null = null;
    public pctInvest: number | null = null;
    public mainContent: string | null = null;
    public notes: string | null = null;
    public marketStrategy: string | null = null;
    public updated: string | null = null;
}
export class Edit {
    private static readonly TRADING_DATE = '#TradingDate';
    private static readonly DAILY_ACTION = '#DailyAction';
    private static readonly CURRENT_OUTLOOK = '#CurrentOutlook';
    private static readonly DISTRIBUTION_DAYS = '#DistributionDays';
    private static readonly NDQ_CHANGE = '#NDQ_Chg';
    private static readonly NDQ_COUNT = '#NDQ_Cnt';
    private static readonly S_AND_P_500_COUNT = '#SP500_Cnt';
    private static readonly S_AND_P_500_CHANGE = '#SP500_Chg';
    private static readonly PCT_INVEST = '#PctInvest';
    private static readonly MAIN_CONTENT = '#MainContent';
    private static readonly NOTES = '#Notes';
    private static readonly MARKET_STRATEGY = '#MarketStrategy';
    private static readonly UPDATED = '#Updated';
    private static readonly SUBMIT = '#Submit';

    constructor() {
        this.init();
    }

    private init() {
        $(Edit.TRADING_DATE).kendoDatePicker({
            dateInput: true
        });

        $(Edit.DAILY_ACTION).kendoMaskedTextBox();

        $(Edit.CURRENT_OUTLOOK).kendoDropDownList({
            dataSource: [
                'Exposure: 0%-20%',
                'Exposure: 20%-40%',
                'Exposure: 40%-60%',
                'Exposure: 60%-80%',
                'Exposure: 80%-100%',
            ],
        });

        $(Edit.DISTRIBUTION_DAYS).kendoMaskedTextBox();

        const changeData = [
            '',
            'DD',
            'Drop',
        ];

        $(Edit.NDQ_CHANGE).kendoDropDownList({
            dataSource: changeData,
        });

        $(Edit.NDQ_COUNT).kendoNumericTextBox({
            format: 'n0',
            min: 0,
            max: 12,
            step: 1
        });

        $(Edit.S_AND_P_500_COUNT).kendoNumericTextBox({
            format: 'n0',
            min: 0,
            max: 12,
            step: 1
        });

        $(Edit.S_AND_P_500_CHANGE).kendoDropDownList({
            dataSource: changeData,
        });

        $(Edit.PCT_INVEST).kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: [
                { text: '0%', value: 0 },
                { text: '20%', value: 0.2 },
                { text: '40%', value: 0.4 },
                { text: '60%', value: 0.6 },
                { text: '80%', value: 0.8 },
            ],
        });

        $(Edit.UPDATED).kendoDatePicker({
            dateInput: true
        });

        $(Edit.SUBMIT).on('click', () => {
            this.save();
        });
    }

    public save() {
        var model = new TheBigPictureModel();
        model.tradingDate = $(Edit.TRADING_DATE).val()?.toString() || null;
        model.dailyAction = $(Edit.DAILY_ACTION).val()?.toString() || null;
        model.currentOutlook = $(Edit.CURRENT_OUTLOOK).val()?.toString() || null;
        model.distributionDays = $(Edit.DISTRIBUTION_DAYS).val()?.toString() || null;
        model.ndqChange = $(Edit.NDQ_CHANGE).val()?.toString() || null;
        model.ndqCount = parseInt($(Edit.NDQ_COUNT).val()?.toString() || '');
        model.sandP500Count = parseInt($(Edit.S_AND_P_500_COUNT).val()?.toString() || '');
        model.sandP500Change = $(Edit.S_AND_P_500_CHANGE).val()?.toString() || null;
        model.pctInvest = parseFloat($(Edit.PCT_INVEST).val()?.toString() || '');
        model.mainContent = $(Edit.MAIN_CONTENT).val()?.toString() || null;
        model.notes = $(Edit.NOTES).val()?.toString() || null;
        model.marketStrategy = $(Edit.MARKET_STRATEGY).val()?.toString() || null;
        model.updated = $(Edit.UPDATED).val()?.toString() || null;

        const msg = new Notification();

        let success = (data: TheBigPictureModel) => {
            msg.success('The record for ' + model.tradingDate + ' was updated successfully');
        };

        let error = () => {
            msg.error('The record for ' + model.tradingDate + ' could not be updated');
        }

        Ajax.invoke(GlobalData.URL_SUFFIX_IBD_LEADERBOARD_THE_BIG_PICTURE,
            'POST', model, success, error);
    }
}
